import OSS from 'ali-oss';
import { aliyunStsToken } from '@/utils/api/apis.js'
import { LocalStorageKeys } from '@/utils/local_storage.js'
import { rsaDecryptWithPrivateKey } from '@/utils/sign_utils.js';

// 这里我们将 OSS 客户端的初始化函数暴露出来
let userInfo = null;
let clientMap = null;

export const setUserInfo = (info) => {
  userInfo = info;
};

// 初始化 OSS 客户端
export const initOSSClient = async () => {
  // 获取 STS Token 并初始化 OSS 客户端
  const base = await aliyunStsToken();
  let client = new OSS({
    region: base.data.endpoint.split('.')[0], // 设置 OSS 区域
    accessKeyId: base.data.AccessKeyId, // 访问密钥 ID
    accessKeySecret: base.data.AccessKeySecret, // 访问密钥
    bucket: base.data.bucket, // OSS 桶名称
    stsToken: base.data.SecurityToken, // STS Token
    exposeHeaders: ['ETag', 'x-oss-request-id'],// 添加如下配置，指定要暴露的响应头
  });
  clientMap = {client: client, time: Date.now()}
  return clientMap;
};

// 上传文件
export const ossUploadFile = async (uploadItem, onProgress, onCheckpoint) => {
  await checkOssClient(uploadItem);
  try {
    if (userInfo == null) {
      const userInfoDe = await rsaDecryptWithPrivateKey(localStorage.getItem(LocalStorageKeys.USER_INFO));
      userInfo = JSON.parse(userInfoDe);
    }
    const result = await uploadItem.ossClient.multipartUpload('user_' + userInfo.id + '/' + uploadItem.file.name, uploadItem.file, {
      checkpoint: uploadItem.checkpoint,
      progress: (percentage, checkpoint) => {
        if (onProgress) {
          onProgress(percentage); // 调用外部传入的回调，更新上传进度
        }
        if (checkpoint) {
          onCheckpoint(checkpoint)
        }
      }
    });
    // console.log('Complete Request ID:', result.res.headers['x-oss-request-id']);
    return result;
  } catch (err) {
    console.log(err, 'oss err')
    throw err;
  }
};

// 暂停上传
export const ossPauseUpload = async (uploadItem) => {
  if (uploadItem.ossClient) {
    // 暂停当前任务
    await uploadItem.ossClient.cancel();
  }
};

// 获取文件下载链接
export const ossGetFileUrl = (fileName) => {
  return client.signatureUrl(fileName, {
    expires: 3600
  }); // 设置链接有效期
};

// 下载文件
export const ossDownloadFile = async (fileName) => {
  if (!clientMap || (Date.now() - clientMap.time) > 3300000) {
    await initOSSClient();
  }

  const {client, time} = clientMap;

  try {
    // const result = await client.get(fileName);
    // // console.log('Get Request ID:', result.res.headers);
    // // 创建 Blob 并触发浏览器下载
    // const blob = new Blob([result.content], { type: result.res.headers['content-type'] });
    // const url = window.URL.createObjectURL(blob);
    // const link = document.createElement('a');
    // link.href = url;
    // link.download = fileName.split('/').pop(); // 提取文件名
    // link.click();
    // window.URL.revokeObjectURL(url); // 释放 URL
    // return result;

    var url = await client.signatureUrlV4('GET', 3600, {
      headers: {} // 请根据实际发送的请求头设置此处的请求头
    }, fileName)

    // 创建一个临时的 <a> 标签来触发下载
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName.split('/').pop(); // 提取文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  } catch (err) {
    // throw fileName + '文件异常';
    throw err;
  }
};

const checkOssClient = async (uploadItem) => {
  if (uploadItem.ossClient && uploadItem.ossClientTime && (Date.now() - uploadItem.ossClientTime) < 3300000) {
    return uploadItem;
  }
  var initOssRes = await initOSSClient();
  uploadItem.ossClient = initOssRes.client
  uploadItem.ossClientTime = initOssRes.time
  return uploadItem;
}



// WEBPACK FOOTER //
// ./src/utils/oss.js